module.exports = __webpack_public_path__ + "img/default_avatar.7c1a71ce.png";